<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('auth.top33') || '積分記錄'" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <div v-if="list.length === 0" class="empty-tip">
          暫無記錄
        </div>
        <div class="record-item van-hairline--bottom" v-for="(v, key) in list" :key="key">
          <div class="record-info">
            <div class="record-title">
              <span v-if="v.type==1">{{ $t('auth.top34') }}</span>
              <span v-else-if="v.type==2">{{ $t('auth.top35') }}</span>
              <span v-else-if="v.type==3">{{ $t('auth.top36') }}</span>
              <span v-else-if="v.type==4">{{ $t('auth.top37') }}</span>
              <span v-else-if="v.type==5">{{ $t('auth.top38') }}</span>
              <span v-else-if="v.type==6">{{ $t('auth.top39') }}</span>
              <span v-else-if="v.type==7">{{ $t('auth.top40') }}</span>
              <span v-else-if="v.type==8">{{ $t('auth.top41') }}</span>
              <span v-else-if="v.type==9">{{ $t('auth.top42') }}</span>
              <span v-else>{{ v.type_name || '積分變動' }}</span>
            </div>
            <div class="record-time">{{ v.addtime }}</div>
          </div>
          <div class="record-amount">
            <span v-if="v.status==2" class="minus">-{{ v.num }}</span>
            <span v-else class="plus">+{{ v.num }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_money_list'
      }).then(res => {
        if (res && res.code === 200) {
          this.list = res.data || [];
        } else if (res) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
}

.record-info {
  display: flex;
  flex-direction: column;
}

.record-title {
  font-size: 28px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.record-time {
  font-size: 24px;
  color: #999999;
}

.record-amount {
  font-size: 30px;
  font-weight: 700;
}

.record-amount .minus {
  color: #f26060;
}

.record-amount .plus {
  color: #3cd197;
}

.empty-tip {
  text-align: center;
  padding: 60px 0;
  color: #999999;
  font-size: 28px;
}
</style>
